import getCampaignTreeType from "common/src/components/CLCardsMap/utils/getCampaignTreeType";
import { CampaignTreeNodes, CampaignTreeType } from "../../campaigns/campaigns.types";
import { Nodes } from "../../nodes/nodes.types";

export const nodesRef: CampaignTreeNodes & {value: Nodes} = {
  [CampaignTreeType.Concept]: {},
  [CampaignTreeType.Campaign]: {},

  get value() {
    const campaignTreeType = getCampaignTreeType();

    return nodesRef[campaignTreeType];
  },
};
